export default __webpack_public_path__ + "bd19bd65c050a5814bd40910dc802eb4.png";